import React, { memo, useMemo } from 'react'

import { Button, Icon, Search, ImageAddPlus, BrushAI } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { setImageAssistantTab } from 'Pods/ThreeDStudio/Store/actions/ui'
import { IMAGE_ASSISTANT_TAB } from 'Pods/ThreeDStudio/Store/constants'

const TAB_DEFS = [
  { id: IMAGE_ASSISTANT_TAB.SEARCH, labelKey: 'imageAssistantPanel.tabs.search', icon: Search, color: 'darker' },
  { id: IMAGE_ASSISTANT_TAB.CREATE, labelKey: 'imageAssistantPanel.tabs.create', icon: ImageAddPlus, color: 'darker' },
  { id: IMAGE_ASSISTANT_TAB.EDIT, labelKey: 'imageAssistantPanel.tabs.edit', icon: BrushAI, color: 'darker' },
]

function Tabs({ activeTab, imageSearchOnIdeationFLowEnabled }) {
  const t = useTranslation()
  const buttons = useMemo(() => TAB_DEFS
    .filter(tab => imageSearchOnIdeationFLowEnabled || tab.id !== IMAGE_ASSISTANT_TAB.SEARCH)
    .map(tab => ({
      ...tab,
      onClick: () => setImageAssistantTab(tab.id),
    })), [imageSearchOnIdeationFLowEnabled])

  return (
    <div className="image-assistant-panel__tabs">
      {buttons.map(({ id, labelKey, icon, onClick }) => (
        <Button
          key={id}
          type="secondary"
          variant="with-icon"
          size="tiny"
          expand
          customClass="image-assistant-panel__tab"
          isActive={activeTab === id}
          onClick={onClick}
        >
          <span className="image-assistant-panel__tab-content">
            <Icon svgComponent={icon} color="darker" size={iconSize} notSpaced />
            {t(labelKey)}
          </span>
        </Button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  activeTab: string.isRequired,
  imageSearchOnIdeationFLowEnabled: bool.isRequired,
}

export default memo(Tabs)
